<template>
  <div v-if="errorData">
    <McAlert
      class="mb-4"
      :variant="errorData?.alert"
      withIcon
      :customIcon="errorData?.icon"
      style="padding-bottom: 0px"
    >
      <template #label>
        <div>
          <p>
            {{ errorData?.message }}
            <span v-if="errorData?.key === 'delivery_orders' && errorData?.hasDetail" class="ms-1">
              <a class="text-primary" @click="handleViewDetailClick">
                {{ $t('routeOptimization.modal.notOptimized.action.viewDetail') }}
              </a>
            </span>
          </p>
        </div>
      </template>
    </McAlert>

    <b-modal
      v-if="tableItems.length > 0"
      id="mc-modal-do-list"
      class="mc-modal"
      :title="$t('routeOptimization.label.orderList')"
      size="lg"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <b-table class="table-wrapper" :fields="fields" :items="tableItems" />
        <p class="mt-3">{{ $t('global.text.display') }} {{ tableItems.length }} {{ 'data.' }}</p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel()"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { errorCreateRoMappings } from '@/router/views/route-optimization/lib/constants/error-mappings'
import McAlert from '@/components/McAlert'
import McTable from '@/components/McTable'
import McButton from '@/components/McButton'

export default {
  components: {
    McAlert,
    McTable,
    McButton,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    errorData() {
      const errors = this.errors || {}
      const [rawKey] = Object.keys(errors)

      if (!rawKey) return null

      const key = rawKey.split('.')[0]
      const firstReason = Array.isArray(errors[rawKey]) ? errors[rawKey][0] : null

      const totalDOs = Object.keys(errors).filter((key) =>
        key.startsWith('delivery_orders.')
      ).length

      const errorMap = {
        vehicle_ids: {
          key,
          alert: 'error',
          message: this.$t(errorCreateRoMappings[firstReason]),
          icon: 'icon-fill_alert-circle',
        },
        delivery_orders: {
          key,
          alert: 'error',
          message:
            totalDOs > 0
              ? this.$t(errorCreateRoMappings['deliveries could not be processed'], {
                  totalDOs,
                })
              : this.$t(errorCreateRoMappings[firstReason]),
          icon: 'icon-fill_alert-circle',
          hasDetail: totalDOs > 0,
        },
      }
      return errorMap[key] || null
    },
    fields() {
      return [
        {
          label: this.$t('routeOptimization.fields.doNumber'),
          key: 'number',
          isSortable: true,
          isRedirectable: false,
          thClass: 'th',
        },
        {
          label: this.$t('routeOptimization.fields.reason'),
          key: 'reason',
          isSortable: false,
          thClass: 'th',
        },
      ]
    },
    tableItems() {
      const items = []
      Object.entries(this.errors || {}).forEach(([key, reasons]) => {
        if (!Array.isArray(reasons)) return

        const doNumber = key.split('.').pop()
        reasons.forEach((reason) => {
          items.push({
            number: doNumber,
            reason: this.$t(errorCreateRoMappings[reason]) || reason,
          })
        })
      })
      return items
    },
  },
  methods: {
    handleViewDetailClick() {
      this.$bvModal.show('mc-modal-do-list')
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  border-collapse: collapse;
  border: 1px solid $teal-100;

  ::v-deep .th {
    border: 1px solid $teal-100;
  }

  ::v-deep td {
    border: 1px solid $teal-100;
  }
}
</style>
